import { resolveComponent as _resolveComponent, withKeys as _withKeys, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "loginas-dialog" }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"height":"10px"} }, null, -1)
const _hoisted_5 = { class: "flex-grow-1 flex flex-column align-items-center justify-content-center" }
const _hoisted_6 = { class: "mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ElementsEmptyIndicator = _resolveComponent("ElementsEmptyIndicator")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    class: "loginas-edition-dialog",
    header: _ctx.$filters.capitalizeFirstLetter(_ctx.$t('login_as')),
    visible: _ctx.displayDialog,
    "onUpdate:visible": _ctx.closeDialog,
    maximizable: true,
    modal: true,
    style: { width: '70vw' },
    onHide: _ctx.closeDialog
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_InputText, {
              autocomplete: "off",
              spellcheck: "false",
              modelValue: _ctx.searchText,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
              onKeydown: _withKeys(_ctx.search, ["enter"]),
              type: "search",
              autofocus: ""
            }, null, 8, ["modelValue", "onKeydown"]),
            _createVNode(_component_Button, {
              class: "ml-2 background-gradient-sunrise",
              onClick: _ctx.search,
              label: _ctx.$t('search'),
              icon: "fas fa-search"
            }, null, 8, ["onClick", "label"])
          ]),
          _hoisted_4,
          _createVNode(_component_DataTable, {
            value: _ctx.users,
            loading: _ctx.loading,
            dataKey: "global_user_uid",
            responsiveLayout: "scroll"
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_ElementsEmptyIndicator, {
                indicator: 'no_result',
                description: _ctx.$t('no_records_found')
              }, null, 8, ["description"])
            ]),
            loading: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_ProgressSpinner),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$filters.capitalizeFirstLetter(_ctx.$t("loading_in_progress"))), 1)
              ])
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "organization_id",
                header: "Organization ID"
              }),
              _createVNode(_component_Column, {
                field: "organization_name",
                header: "Organization Name"
              }),
              _createVNode(_component_Column, {
                field: "global_user_name",
                header: "Name"
              }),
              _createVNode(_component_Column, {
                field: "global_user_email",
                header: "Email"
              }),
              _createVNode(_component_Column, {
                field: "store_names",
                header: "Stores",
                style: {"max-width":"8rem"}
              }),
              _createVNode(_component_Column, {
                exportable: false,
                style: {"min-width":"8rem"}
              }, {
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "pi pi-check",
                    class: "p-button p-button-rounded mr-2 background-gradient-gold",
                    label: _ctx.$filters.capitalizeFirstLetter(_ctx.$t('login')),
                    onClick: ($event: any) => (_ctx.loginAs(slotProps.data))
                  }, null, 8, ["label", "onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value", "loading"])
        ])
      ], 512), [
        [_vShow, _ctx.displayDialog]
      ])
    ]),
    _: 1
  }, 8, ["header", "visible", "onUpdate:visible", "onHide"]))
}